module.exports = __webpack_public_path__ + "static/intellrobotslab_team-ea7f2e0b5b2207d1805c13377a13e4a5.jpg";